import * as React from 'react';
import * as Styled from './DashboardEdit.styled';
import { generateFixedDashboardLayout, getCollidingElementIds, cloneComponentConfigs, isOutOfRange, findAvailableLocation, } from '../Dashboard.utils';
import { DashboardEditGuide } from './DashboardEditGuide/DashboardEditGuide';
import { DashboardEditComponent } from './DashboardEditComponent/DashboardEditComponent';
export const DashboardEdit = (props) => {
    const { name, value, onChange } = props;
    const { config, components = [] } = value;
    const { layout, height } = generateFixedDashboardLayout(value, 1608);
    const root = React.useRef(null);
    const [columnWidth, setColumnWidth] = React.useState(0);
    const [offsetLeft, setOffsetLeft] = React.useState(0);
    const [offsetTop, setOffsetTop] = React.useState(0);
    React.useEffect(() => {
        if (!root.current)
            return;
        const { current } = root;
        const colWidth = (current.clientWidth - config.gutter * (config.columnCount - 1)) /
            config.columnCount;
        const boundingRect = current.getBoundingClientRect();
        setColumnWidth(colWidth);
        setOffsetLeft(boundingRect.left);
        setOffsetTop(boundingRect.top);
    }, [config.columnCount, config.gutter]);
    const handleUpdated = (index, top, left) => {
        if (components[index].top === top && components[index].left === left)
            return;
        if (isOutOfRange(config.columnCount, top, left, components[index].width))
            return;
        const temp = Object.assign(Object.assign({}, components[index]), { top, left });
        // Keeps track of changes due to collision
        const cloned = cloneComponentConfigs(components);
        cloned[index] = temp;
        const collidingElementIds = getCollidingElementIds(layout, config.columnCount, temp);
        while (collidingElementIds.length > 0) {
            const collidingElementId = collidingElementIds[0];
            const collidingElement = value.components.find((val) => val.id === collidingElementId);
            const colIndex = cloned.findIndex((val) => val.id === collidingElementId);
            // Temporarily remove the colliding element from dashboard
            cloned[colIndex].top = -1;
            cloned[colIndex].left = -1;
            // Find a new location for the colliding element
            const { layout: updatedLayout } = generateFixedDashboardLayout({
                config,
                components: cloned,
            }, 1608);
            const newLocation = findAvailableLocation(updatedLayout, config.columnCount, collidingElement);
            cloned[colIndex].top = newLocation.top;
            cloned[colIndex].left = newLocation.left;
            collidingElementIds.shift();
        }
        onChange(name, {
            config,
            components: cloned,
        });
    };
    const handleDeleted = (index) => {
        const cloned = cloneComponentConfigs(components);
        cloned.splice(index, 1);
        onChange(name, {
            config,
            components: cloned,
        });
    };
    return (React.createElement(Styled.Root, { style: { height }, ref: root, onDragOver: (e) => {
            e.preventDefault();
        } },
        React.createElement(DashboardEditGuide, { config: config, height: layout.length }),
        components.map((componentConfig, index) => (React.createElement(DashboardEditComponent, { key: componentConfig.id, index: index, columnWidth: columnWidth, offsetLeft: offsetLeft, offsetTop: offsetTop, onUpdate: handleUpdated, onDelete: handleDeleted, dashboardConfig: config, componentConfig: componentConfig })))));
};
//# sourceMappingURL=DashboardEdit.js.map